<template>
  <div class="app-tag-add-modal t-modal" :class="{ open: isOpen }">
    <div v-down-outside="close" class="content">
      <header>Add Tag</header>
      <form class="main" @submit="save">
        <div class="title">Tag Name</div>
        <input ref="input" v-model="tag.name" type="text" class="b-input" />
        <div v-if="error.name" class="error-name">* Name is required</div>
        <div class="title">Tag Color</div>
        <!-- <input type="text" class="b-input" /> -->
        <SelectColor :key="tag.id" v-model="tag.color" />
        <div class="controls">
          <div class="cancel b-btn" @click="close">Cancel</div>
          <input
            class="confirm b-btn"
            type="submit"
            value="Save"
            @click="save"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';
import { ModalEvents } from 'app/utils/events';
import SelectColor from 'app/components/common/SelectColor.vue';

export default {
  name: 'TagAddModal',

  components: {
    SelectColor,
  },
  directives: {
    downOutside,
  },
  data() {
    return {
      isOpen: false,
      tag: {
        name: '',
        color: null,
      },

      error: {
        name: false,
      },
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    ModalEvents.addListener('addTag:open', this.open);
    ModalEvents.addListener('addTag:close', this.close);
  },
  destroyed() {
    ModalEvents.removeListener('addTag:open', this.open);
    ModalEvents.removeListener('addTag:close', this.close);
  },
  methods: {
    validate() {
      let valid = true;
      if (!this.tag.name) {
        this.error.name = true;
        valid = false;
      } else {
        if (!this.tag.name.replace(/\s/gi, '')) {
          this.error.name = true;
          valid = false;
        }
      }
      return valid;
    },
    open() {
      this.isOpen = true;
      setTimeout(() => {
        this.$refs.input.focus();
      }, 100);
    },
    close() {
      this.isOpen = false;
      this.tag.name = '';
      this.error.name = false;
    },
    save(e) {
      e.preventDefault();
      if (!this.validate()) {
        return;
      }
      console.log(this.tag);
      this.$store.dispatch('tag/addTag', this.tag);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-tag-add-modal {
  .error-name {
    font-size: 12px;
    margin-top: 4px;
    margin-bottom: -12px;
    color: rgb(255, 96, 96);
  }
}
</style>
